<template>
	<div class="table-graphic">
		<div class="wrapper-graphic-top">
			<div
				class="text-blue text-up inline mr-4"
				:style="`color:${$appColors.primary}`"
			>
				COMUNICACIÓN
			</div>
			<div class="flex column-end mr-3">
				<span
					class="text-bold"
					:style="`color:${$appColors.info}`"
				>ALTA</span>
				<span
					class="text-bold"
					:style="`color:${$appColors.info}`"
				>BAJA</span>
			</div>
			<div class="flex wrapper-number mr-3">
				<div
					v-for="n in 10"
					:key="n"
					class="text-blue-small"
					:style="`color:${$appColors.primary}`"
				>{{n}}</div>
			</div>
			<div class="relative">
				<div
					class="square-weighing"
					:style="`${weighingStyle};color:${$appColors.primary}`"
				>
					<span
						v-if="info"
						class="card-total-tooltip"
						:style="`color:${$appColors.secondary}`"
					>
						<v-layout wrap px-4 justify-space-around>
							<v-flex
								class="not-child-flex"
								xs6 text-xs-center
								v-for="rate in info.ratePolls"
								:key="rate.value"
							>
								<span
									class="card-total-reverse-data text-xs-left"
									:style="`color:${$appColors.info}`"
								>
									{{ Math.round(rate.rate) }}% {{ rate.code }}
								</span>
							</v-flex>
						</v-layout>
						{{ info.interpretation }}: {{ info.definition }}
					</span>
					<span
						v-else
						class="card-total-tooltip"
						:style="`color:${$appColors.secondary}`"
					>
						No se encontró información
					</span>
				</div>
				<div
					class="table flex"
					:style="`border-color:${$appColors.error}`"
				>
					<div class="borders-container">
						<span
							v-for="border in 100"
							:key="border"
							class="border-item"
						></span>
					</div>
					<div
						v-for="weather in climates"
						:key="weather.order"
						:style="`background-image: url(${weather.url})`"
						class="wrapper-image"
					>
						<div v-if="weather.order !== 5" class="wrapper-square">
							<div v-for="n in 25" :key="n" class="square"
								:style="`boder-color:${$appColors.info}`"
							></div>
						</div>
						<div v-else class="wrapper-square">
							<div v-for="n in 16" :key="n" class="square-one"
								:style="`boder-color:${$appColors.info}`"
							></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="wrapper-graphic-down">
			<div
				class="text-blue-small wrapper-abs"
				:style="`color:${$appColors.primary}`"
			>0</div>
			<div class="flex d-around mt-3">
				<div
					v-for="n in 10"
					:key="n"
					class="text-blue-small"
					:style="`color:${$appColors.primary}`"
				>{{n}}</div>
			</div>
			<div class="flex d-between mt-3">
				<span
					class="text-bold"
					:style="`color:${$appColors.info}`"
				>BAJA</span>
				<span
					class="text-bold"
					:style="`color:${$appColors.info}`"
				>ALTA</span>
			</div>
			<div
				class="text-blue center mt-4"
				:style="`color:${$appColors.primary}`"
			>LIDERAZGO </div>
		</div>
	</div>
</template>
<script>
function weighingStyle() {
	const { communication, leadership } = this.weighing;
	const heightOrigin = `height:calc(((100% / 10) * ${communication}))`;
	const widthOrigin = `width:calc(((100% / 10) * ${leadership}))`;
	const height = ((100 / 10) * communication) >= 100 ? 'height:98.5%' : heightOrigin;
	const width = ((100 / 10) * leadership) >= 100 ? 'width:98.5%' : widthOrigin;
	const borderRight = `border-right:5px solid ${this.$appColors.primary}`;
	const borderTop = `border-top:5px solid ${this.$appColors.primary}`;
	return `${height};${width};${borderRight};${borderTop}`;
}

function data() {
	return {
		description: '',
	};
}

export default {
	name: 'table-graphic',
	computed: {
		weighingStyle,
	},
	data,
	props: {
		climates: {
			type: Array,
			default: () => [],
		},
		info: {
			type: Object,
			default: () => {},
		},
		weighing: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="scss" scoped>
	.table-graphic {
		.table {
			border: 4px solid;
			height: 641px;
			position: relative;
			width: 641px;
		}

		.wrapper-image {
			background-size: cover;
			height: 318.5px;
			position: absolute;
			width: 318.5px;

			&:nth-child(2) {
				border-bottom: 1.5px solid map-get($colors, error);
				border-right: 1.5px solid map-get($colors, black-bold);
				left: 0;
				top: 0;
			}

			&:nth-child(3) {
				border-bottom: 1.5px solid map-get($colors, error);
				border-left: 1.5px solid map-get($colors, black-bold);
				right: 0;
				top: 0;
			}

			&:nth-child(4) {
				border-right: 1.5px solid map-get($colors, black-bold);
				border-top: 1.5px solid map-get($colors, black-bold);
				bottom: 0;
				left: 0;
			}

			&:nth-child(5) {
				border-left: 1.5px solid map-get($colors, black-bold);
				border-top: 1.5px solid map-get($colors, black-bold);
				bottom: 0;
				right: 0;
			}

			&:nth-child(6) {
				height: 253.6px;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
				width: 253.6px;
			}
		}

		.square {
			border: 0.5px solid;
			height: 63.4px;
			position: relative;
			width: 63.4px;

			&::before {
				background: rgba(255, 255, 255, 0.5);
				bottom: 0;
				content: '';
				left: 0;
				position: absolute;
				right: 0;
				top: 0;
			}
		}

		.wrapper-square {
			display: flex;
			flex-wrap: wrap;
			height: 100%;
			width: 100%;
		}

		.square-one {
			border: 0.5px solid;
			height: 63.4px;
			position: relative;
			width: 63.4px;

			&::before {
				background: rgba(255, 255, 255, 0.5);
				bottom: 0;
				content: '';
				left: 0;
				position: absolute;
				right: 0;
				top: 0;
			}

			&:nth-child(1),  &:nth-child(2), &:nth-child(3), &:nth-child(4){
				border-top: 2px solid map-get($colors, error);
			}

			&:nth-child(1),  &:nth-child(5), &:nth-child(9), &:nth-child(13){
				border-left: 2px solid map-get($colors, error);
			}

			&:nth-child(4),  &:nth-child(8), &:nth-child(12), &:nth-child(16){
				border-right: 2px solid map-get($colors, error);
			}

			&:nth-child(13),  &:nth-child(14), &:nth-child(15), &:nth-child(16){
				border-bottom: 2px solid map-get($colors, error);
			}

			&:nth-child(2), &:nth-child(6), &:nth-child(10), &:nth-child(14) {
				border-right: 2px solid map-get($colors, info);
			}

			&:nth-child(5), &:nth-child(6), &:nth-child(7), &:nth-child(8)  {
				border-bottom: 1px solid map-get($colors, error);
			}

			&:nth-child(9), &:nth-child(10), &:nth-child(11), &:nth-child(12)  {
				border-top: 1px solid map-get($colors, error);
			}
		}

		.text-blue {
			font-family: map-get($fonts, bold);
			font-size: 25px;
		}

		.text-up {
			text-align: center;
			text-orientation: upright;
			writing-mode: vertical-lr;
		}

		.flex {
			display: flex;
		}

		.inline {
			display: inline-block;
		}

		.text-bold {
			font-family: map-get($fonts, bold);
			font-size: map-get($sizes, sbig);
		}

		.column-end {
			flex-direction: column;
			justify-content: space-between;
		}

		.wrapper-graphic-top {
			display: flex;
			height: 641px;
			margin: auto;
			width: 811px;
		}

		.text-blue-small {
			font-size: map-get($sizes, xlarge);
		}

		.wrapper-number {
			align-items: center;
			flex-direction: column-reverse;
			justify-content: space-around;
		}

		.flex, .child-flex > * {
			&:not(.not-child-flex) {
				flex: inherit;
			}
		}

		.wrapper-graphic-down {
			margin: auto;
			padding-left: 140px;
			position: relative;
			width: 780px;
		}

		.d-around {
			justify-content: space-around;
		}

		.d-between {
			justify-content: space-between;
		}

		.wrapper-abs {
			font-family: map-get($fonts, bold);
			left: 114px;
			position: absolute;
		}

		.square-weighing {
			bottom: 5px;
			left: 5px;
			position: absolute;
			z-index: 2;

			&:before {
				background: currentColor;
				content: '';
				height: 66.39px;
				position: absolute;
				right: 0;
				top: 0;
				width: 66.39px;
			}
		}

		.relative {
			position: relative;
		}
	}

	.borders-container {
		display: flex;
		flex-wrap: wrap;
		position: relative;
		width: 100%;

		.border-item {
			border: 1px solid color(tooltip-gray);
			display: inline-flex;
			height: calc(100% / 10);
			width: calc(100% / 10);

			&:nth-child(5n) {
				border-right: 2px solid color(tooltip-gray);
			}
		}

		&:before,
		&:after {
			content: '';
		}

		&:before {
			border-bottom: 4px solid #ff5741;
			height: 50%;
			position: absolute;
			width: 100%;
			z-index: 1;
		}

		&:after {
			border: 4px solid #ff5741;
			bottom: 0px;
			height: 40%;
			left: 0px;
			margin: auto;
			position: absolute;
			right: 0px;
			top: 0px;
			width: 40%;
			z-index: 1;
		}
	}

	.card-total-tooltip {
		background-color: color(white);
		border-radius: 15px;
		box-shadow: 0 2px 7px 0 rgba(191, 191, 191, 0.5);
		display: none;
		font-family: font(regular);
		font-size: size(medium);
		height: fit-content;
		height: -moz-fit-content;
		margin: auto 0px;
		padding: 22px 13px 22px 26px;
		position: absolute;
		right: -100%;
		text-align: center;
		top: -30%;
		width: fit-content;
		width: -moz-fit-content;
		z-index: 10;

		&:before,
		&:after {
			content: '';
		}

		&:before {
			border-bottom: 6px solid transparent;
			border-right: 12px solid white;
			border-top: 6px solid transparent;
			bottom: 0px;
			height: 6px;
			left: -11px;
			margin: auto;
			position: absolute;
			top: 0px;
			z-index: 1;
		}

		&:after {
			border-bottom: 8px solid transparent;
			border-right: 14px solid rgba(191, 191, 191, 0.5);
			border-top: 8px solid transparent;
			bottom: 0px;
			height: 7px;
			left: -13px;
			margin: auto;
			opacity: 0.4;
			position: absolute;
			top: 0px;
		}

		@media (max-width: 1250px) {
			right: -59%;
			top: -36%;
		}
	}

	.square-weighing:hover {
		.card-total-tooltip	{
			display: inline-block;
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/diagnosis/table-graphic.vue